export class PortalLinkDto {
    id: number;
    url: string;
    description: string;
    image: object;
    imageString: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/portal-link.dto.ts